import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase/credenciales';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faRotate, faAdd, faBan, faReply } from '@fortawesome/free-solid-svg-icons';
import './SettingController.css';
import { use } from "react";

const SettingController = () => {
    const [controller, setController] = useState([]);
    const [filteredController, setFilteredController] = useState([]);
    const [search, setSearch] = useState("");
    const [editingController, setEditingController] = useState(null);
    const [newController, setNewController] = useState({
        Brand: "",
        Description: "",
        Amperes: "",
        Voltage: "",
        Price: "",
    });
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchController = async () => {
        const querySnapshot = await getDocs(collection(db, 'Controladores'));
        const controllersData = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        setController(controllersData);
        setFilteredController(controllersData);
        setLoading(false);
    };
    useEffect(() => {
        fetchController();
    }, []);
    useEffect(() => {
        setFilteredController(
            controller.filter(controller =>
                controller.Brand.toLowerCase().includes(search.toLowerCase())
            )
        );
    }, [search, controller]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewController({
            ...newController,
            [name]: value,
        });
    };

    const handleEditController = (controller) => {
        setEditingController(controller);
        setNewController(controller);
    };

    const handleUpdateController = async () => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "¿Deseas actualizar este controllador?",
            showCancelButton: true,
            confirmButtonText: "Sí, actualizar!",
            cancelButtonText: "No, cancelar",
        });
        if (result.isConfirmed) {
            try {
                await updateDoc(doc(db, 'Controladores', editingController.id), newController);
                Swal.fire("Actualizado", "El controlador ha sido actualizado exitosamente.");
                setEditingController(null);
                setNewController({
                    Brand: "",
                    Description: "",
                    Amperes: "",
                    Voltage: "",
                    Price: "",
                });
                fetchController();
            } catch (error) {
                console.error("Error al actualizar el controlador en la base de datos", error);
                Swal.fire("Error", "No se pudo actualizar el controlador.");
            }
        }
    };

    const handleDeleteController = async (id) => {
        const result = await Swal.fire({
            title: "¿Estás seguro?",
            text: "No podrás revertir esto!",
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar!",
            cancelButtonText: "No, cancelar",
        });
        if (result.isConfirmed) {
            try {
                await deleteDoc(doc(db, 'Controladores', id));
                Swal.fire("Borrado!", "El controlador ha sido borrado.");
                fetchController();
            } catch (error) {
                console.error("Error al eliminar el controlador en la base de datos", error);
                Swal.fire("Error", "No se pudo eliminar el controlador.");
            }
        }
    };

    return (
        <div className="setting-controller-container">
            <div className="titlec-actions">
                <h1 className="titlec">Gestión de controladores</h1>
                <div className="btn-actions">
                    <button className="btn-cancel" title="Regresar" onClick={() => navigate('/admin')}><FontAwesomeIcon icon={faReply} /></button>
                    <button className="btn-plus" title="Agregar una batería" onClick={() => navigate('/admin/inversores')}><FontAwesomeIcon icon={faAdd} /></button>
                </div>
            </div>
            <input
                type="text"
                placeholder="Buscar por la marca del controlador"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="search-input"
            />
            {loading ? (
                <div className="spinner"></div>
            ) : (
                <div className="controller-list">
                    {filteredController.length === 0 ? (
                        <p className="no-results">El controlador que buscas no se encuentra registrado aún.</p>
                    ) : (
                        isMobile ? (
                            filteredController.map(controller => (
                                <div key={controller.id} className="controller-card">
                                    {editingController && editingController.id === controller.id ? (
                                        <div className="edit-form">
                                            <div className="form-group">
                                                <label htmlFor="Brand">Marca</label>
                                                <input
                                                    type="text"
                                                    name="Brand"
                                                    value={newController.Brand}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Description">Descripción</label>
                                                <textarea
                                                    name="Description"
                                                    value={newController.Description}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Amperes">Amperes</label>
                                                <input
                                                    type="number"
                                                    name="Amperes"
                                                    value={newController.Amperes}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Voltage">Voltaje</label>
                                                <input
                                                    type="number"
                                                    name="Voltage"
                                                    value={newController.Voltage}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="Price">Precio</label>
                                                <input
                                                    type="number"
                                                    name="Price"
                                                    value={newController.Price}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                            <div className="btn-form-actions">
                                                <button className="btn-ac" title="Guardar" onClick={handleUpdateController}><FontAwesomeIcon icon={faAdd} /></button>
                                                <button className="btn-de" title="Cancelar" onClick={() => setEditingController(null)}><FontAwesomeIcon icon={faBan} /></button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="controller-info">
                                                <h3>{controller.Brand}</h3>
                                                <p><strong>Descripcion:</strong> {controller.Description}</p>
                                                <p><strong>Amperes:</strong> {controller.Amperes}</p>
                                                <p><strong>Voltaje:</strong> {controller.Voltage}</p>
                                                <p><strong>Precio:</strong> {controller.Price}</p>
                                            </div>
                                            <div className="btn-actions">
                                                <button className="btn-ed" title="Actualizar" onClick={() => handleEditController(controller)}><FontAwesomeIcon icon={faRotate} /></button>
                                                <button className="btn-de" title="Eliminar" onClick={() => handleDeleteController(controller.id)}><FontAwesomeIcon icon={faTrash} /></button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="controller-list">
                                <div className="controller-header">
                                    <span>Marca</span>
                                    <span>Descripción</span>
                                    <span>Amperes</span>
                                    <span>Voltaje</span>
                                    <span>Precio</span>
                                    <span>Acciones</span>
                                </div>
                                <ul>
                                    {filteredController.map(controller => (
                                        <li key={controller.id}>
                                            {editingController && editingController.id === controller.id ? (
                                                <div className="edit-form">
                                                    <input
                                                        type="text"
                                                        name="Brand"
                                                        value={newController.Brand}
                                                        onChange={handleInputChange}
                                                    />
                                                    <textarea
                                                        name="Description"
                                                        value={newController.Description}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="number"
                                                        name="Amperes"
                                                        value={newController.Amperes}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="number"
                                                        name="Voltage"
                                                        value={newController.Voltage}
                                                        onChange={handleInputChange}
                                                    />
                                                    <input
                                                        type="number"
                                                        name="Price"
                                                        value={newController.Price}
                                                        onChange={handleInputChange}
                                                    />
                                                    <div className="btn-actions">
                                                        <button className="btn-ac" title="Guardar" onClick={handleUpdateController}> <FontAwesomeIcon icon={faAdd} /></button>
                                                        <button className="btn-de" title="Cancelar" onClick={() => setEditingController(null)}><FontAwesomeIcon icon={faBan} /></button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <>
                                                    <span>{controller.Brand}</span>
                                                    <span>{controller.Description}</span>
                                                    <span>{controller.Amperes}</span>
                                                    <span>{controller.Voltage}</span>
                                                    <span>{controller.Price}</span>
                                                    <button className="btn-ed" title="Actualizar" onClick={() => handleEditController(controller)}> <FontAwesomeIcon icon={faRotate} /></button>
                                                    <button className="btn-de" title="Eliminar" onClick={() => handleDeleteController(controller.id)}><FontAwesomeIcon icon={faTrash} /></button>
                                                </>
                                            )}
                                        </li>
                                    ))}
                                </ul>

                            </div>
                        )
                    )}
                </div>
            )}
        </div>
    );
}

export default SettingController;